/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listCustomerLightningPayments} from '../api'

export const useMutationListCustomerLightningPayments = createReactQueryMutationHook('listCustomerLightningPayments', listCustomerLightningPayments)
